/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_LifetimeInputs */

const en_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifetime`)
};

const es_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De por vida`)
};

const fr_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À vie`)
};

const de_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Lebenszeit`)
};

const ja_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライフタイム (買い切り)`)
};

const zh_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`终身版`)
};

const ar_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدى الحياة`)
};

const id_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seumur Hidup`)
};

const it_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Vita (Lifetime)`)
};

const ru_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожизненно`)
};

const pt_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitalício`)
};

const ko_val_lifetime = /** @type {(inputs: Val_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`평생 소장`)
};

/**
* | output |
* | --- |
* | "Lifetime" |
*
* @param {Val_LifetimeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_lifetime = /** @type {((inputs?: Val_LifetimeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_LifetimeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_lifetime(inputs)
	if (locale === "es") return es_val_lifetime(inputs)
	if (locale === "fr") return fr_val_lifetime(inputs)
	if (locale === "de") return de_val_lifetime(inputs)
	if (locale === "ja") return ja_val_lifetime(inputs)
	if (locale === "zh") return zh_val_lifetime(inputs)
	if (locale === "ar") return ar_val_lifetime(inputs)
	if (locale === "id") return id_val_lifetime(inputs)
	if (locale === "it") return it_val_lifetime(inputs)
	if (locale === "ru") return ru_val_lifetime(inputs)
	if (locale === "pt") return pt_val_lifetime(inputs)
	return ko_val_lifetime(inputs)
});